"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MessageWithShortcutKey = require("./MessageWithShortcutKey");

var _MessageWithShortcutKey2 = _interopRequireDefault(_MessageWithShortcutKey);

require("./Tooltip.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arrowHeight = 5;
var arrowOffset = 15;
var alignClasses = {
  topRight: "top-right",
  topLeft: "top-left",
  topMiddle: "top-middle",
  bottomRight: "bottom-right",
  bottomLeft: "bottom-left",
  bottomMiddle: "bottom-middle",
  rightMiddle: "right"
};

var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.$tooltipWrapper = null;
    _this.$tooltip = null;
    _this.emptyClass = _this.props.message ? "aclui-tooltip--has-content" : "";
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.$tooltip.style.maxWidth = this.props["max-width"] + "px";
      this.setTooltipTop();
      this.setTooltipLeft();
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      this.emptyClass = nextProps.message ? "aclui-tooltip--has-content" : "";
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.$tooltip.style.maxWidth = this.props["max-width"] + "px";
    }
  }, {
    key: "setTooltipTop",
    value: function setTooltipTop() {
      var $tooltipTrigger = this.$tooltipWrapper.querySelector(".aclui-tooltip__trigger");
      var triggerTop = $tooltipTrigger.offsetTop + $tooltipTrigger.scrollTop;
      var triggerHeight = $tooltipTrigger.offsetHeight;
      var triggerMiddle = triggerTop + triggerHeight / 2;

      var backupDisplayStyle = this.$tooltip.style.display;
      this.$tooltip.style.display = "inline-block";
      var tooltipHeight = this.$tooltip.offsetHeight + arrowHeight;
      this.$tooltip.style.display = backupDisplayStyle;

      if ("topRight topLeft topMiddle".includes(this.props.align)) {
        this.$tooltip.style.top = triggerTop - tooltipHeight + "px";
      } else if (this.props.align === "rightMiddle") {
        this.$tooltip.style.top = triggerMiddle - tooltipHeight / 2 + "px";
      } else {
        this.$tooltip.style.top = triggerTop + triggerHeight + arrowHeight + "px";
      }
    }
  }, {
    key: "setTooltipLeft",
    value: function setTooltipLeft() {
      var $tooltipTrigger = this.$tooltipWrapper.querySelector(".aclui-tooltip__trigger");
      var triggerWidth = $tooltipTrigger.offsetWidth;
      var triggerLeft = $tooltipTrigger.offsetLeft;
      var triggerMiddle = triggerLeft + triggerWidth / 2;

      if ("topRight bottomRight".includes(this.props.align)) {
        this.$tooltip.style.left = triggerLeft - arrowOffset + triggerWidth / 2 + "px";
      } else if ("rightMiddle".includes(this.props.align)) {
        this.$tooltip.style.left = triggerLeft + triggerWidth + arrowHeight + "px";
      } else if ("topLeft bottomLeft".includes(this.props.align)) {
        this.$tooltip.style.left = triggerMiddle - this.$tooltip.offsetWidth + arrowOffset + "px";
      } else {
        this.$tooltip.style.left = triggerMiddle - this.$tooltip.offsetWidth / 2 + "px";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "span",
        {
          className: "aclui-tooltip__wrapper " + this.emptyClass,
          ref: function ref(comp) {
            _this2.$tooltipWrapper = comp;
          }
        },
        _react2.default.createElement(
          "span",
          { className: "aclui-tooltip__trigger" },
          this.props.children,
          _react2.default.createElement(
            "span",
            {
              className: "aclui-tooltip aclui-tooltip--" + alignClasses[this.props.align],
              ref: function ref(comp) {
                _this2.$tooltip = comp;
              }
            },
            this.props.message
          )
        )
      );
    }
  }]);

  return Tooltip;
}(_react2.default.Component);

Tooltip.propTypes = {
  message: _propTypes2.default.node.isRequired,
  children: _propTypes2.default.node.isRequired,
  "max-width": _propTypes2.default.number,
  align: _propTypes2.default.oneOf(["topRight", "topLeft", "topMiddle", "bottomRight", "bottomLeft", "bottomMiddle", "rightMiddle"])
};

Tooltip.defaultProps = {
  "max-width": 300,
  align: "topRight"
};

Tooltip.MessageWithShortcutKey = _MessageWithShortcutKey2.default;

exports.default = Tooltip;